import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm$postLog;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("d2-container", [_c("div", {
    staticClass: "wlc-form"
  }, [_c("el-form", {
    staticClass: "wlc-form-section user-card",
    attrs: {
      "label-width": "70px"
    }
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v(" 社区基本信息"), _c("span", [_vm._v(" | 注册时间：" + _vm._s(_vm.userForm.createTime))])]), _c("el-form-item", {
    attrs: {
      label: "用户头像"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      width: "140px",
      height: "140px",
      url: _vm.userForm.avatar,
      preview: true,
      random: true,
      multimediaType: "userProfilePic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.userForm, "avatar", $event);
      }
    }
  }), _c("div", {
    staticClass: "user-info"
  }, [_vm.userRechargeType(_vm.userForm).label ? _c("div", [_vm._v("用户类型 ： "), _c("span", {
    class: _vm.userRechargeType(_vm.userForm).color
  }, [_vm._v(" " + _vm._s(_vm.userRechargeType(_vm.userForm).label) + " ")])]) : _vm._e(), _c("div", {
    staticClass: "from"
  }, [_vm._v(" 来自： "), _vm.userForm.scene == 1 ? _c("span", [_vm._v("用户裂变")]) : _vm.userForm.scene == 2 ? _c("span", [_vm._v("城市大使 ")]) : _c("span", [_vm._v("自然用户")])]), _vm.userForm.newestAppInfo ? _c("div", {
    staticClass: "ip-facility"
  }, [_vm.userForm.newestAppInfo.phoneBrand ? _c("span", [_vm._v(_vm._s(_vm.userForm.newestAppInfo && _vm.userForm.newestAppInfo.phoneBrand) + " - ")]) : _vm._e(), _c("span", [_vm._v(_vm._s(_vm.userForm.newestAppInfo && _vm.userForm.newestAppInfo.phoneModel))])]) : _vm._e(), _c("div", {
    staticClass: "device-risk"
  }, [_vm.deviceRisk.risk_code ? _c("div", {
    staticClass: "row"
  }, [_vm.deviceRisk.risk_code.length ? _c("div", {
    staticClass: "col",
    class: {
      "col-gray": _vm.deviceRisk.risk_level == -1
    }
  }, [_c("span", [_vm._v("数盟 - " + _vm._s(_vm.deviceRisk.risk_code.join("/")))])]) : _vm._e(), _vm.deviceRisk.risk_code.length && (_vm.deviceRisk.status == 1 || _vm.deviceRisk.status == 2) ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.deviceRisk.status == 1 ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危标记设备 ")]) : _vm._e(), _vm.deviceRisk.status == 2 ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危感知源 "), _vm.deviceRisk.status_remark ? _c("span", [_vm._v(" : " + _vm._s(_vm.deviceRisk.status_remark) + " ")]) : _vm._e()]) : _vm._e(), _vm.deviceRisk.perception_code ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.deviceRisk.perception_code ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危Wi-Fi感知 "), _vm.getPerceptionCodeName ? _c("span", [_vm._v(": " + _vm._s(_vm.getPerceptionCodeName))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm.deviceRisk.relevance_account > 1 ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col"
  }, [_c("span", [_vm._v(" 数盟 - 关联账号 * " + _vm._s(_vm.deviceRisk.relevance_account) + "： ")]), _c("wlc-user-list-pop", {
    attrs: {
      list: _vm.deviceRisk.user_list
    }
  })], 1), _vm.deviceRisk.relevance_account > 1 && _vm.deviceRisk.status == 0 && !_vm.deviceRisk.perception_code ? _c("div", {
    staticClass: "col"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "danger",
      plain: ""
    },
    on: {
      click: _vm.goDeviceList
    }
  }, [_vm._v("设高危 ")])], 1) : _vm._e()]) : _vm._e()]), _c("div", {
    staticClass: "mtb4"
  }, [_vm.userForm.virtualNumber ? _c("el-tag", {
    staticClass: "mr8 wlc-important-tag",
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v("虚拟号 ")]) : _vm._e(), _vm.userForm.phoneCounty && _vm.userForm.phoneCounty != "中国" ? _c("el-tag", {
    staticClass: "mr8 wlc-important-tag",
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(_vm._s(_vm.userForm.phoneCounty) + " ")]) : _vm._e(), _c("el-input", {
    staticClass: "w200",
    attrs: {
      size: "mini",
      disabled: ""
    },
    model: {
      value: _vm.userForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "phone", $$v);
      },
      expression: "userForm.phone"
    }
  }, [_c("el-button", {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.userForm.phone,
      expression: "userForm.phone",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.onCopy,
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: _vm.onError,
      expression: "onError",
      arg: "error"
    }],
    attrs: {
      slot: "append",
      icon: "el-icon-document-copy"
    },
    slot: "append"
  }, [_vm._v("复制 ")])], 1)], 1)]), _vm.userTag.length > 0 ? _c("div", {
    staticClass: "user-tag"
  }, [_c("wlc-user-table-tag", {
    attrs: {
      height: "120px",
      width: "320px",
      userId: _vm.$route.query.userId,
      list: _vm.userTag
    }
  })], 1) : _vm._e(), !_vm.loading ? _c("wlc-radar-chart", {
    attrs: {
      id: _vm.userForm.id
    }
  }) : _vm._e()], 1), _c("el-row", {
    staticClass: "mtb20",
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "昵称",
      "label-width": "140px"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.userForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "name", $$v);
      },
      expression: "userForm.name"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "备注"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.userForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "remark", $$v);
      },
      expression: "userForm.remark"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "职业"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.userForm.occupation,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "occupation", $$v);
      },
      expression: "userForm.occupation"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "个人说明（主页）",
      "label-width": "140px"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.userForm.introduce,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "introduce", $$v);
      },
      expression: "userForm.introduce"
    }
  })], 1)], 1)], 1)], 1), _c("wlc-conversation-list"), _c("el-form", {
    staticClass: "wlc-form-section upload-container"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("图片&视频")]), _c("div", {
    staticClass: "wlc-video-action"
  }, [_vm.form.video_url && !_vm.form.image_urls.includes(_vm.form.cover_url) ? _c("div", {
    staticClass: "wlc-video-cover"
  }, [_c("span", [_vm._v("封面")]), _c("wlc-image", {
    attrs: {
      src: _vm.form.cover_url,
      width: "200",
      height: "150",
      compression: false,
      multimediaType: "wellceeCommunity"
    }
  })], 1) : _c("wlc-upload-video", {
    attrs: {
      width: "200px",
      height: "150px",
      url: _vm.form.video_url,
      multimediaType: "wellceeCommunityVideo"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "video_url", $event);
      }
    }
  }), _vm.form.video_url ? _c("div", {
    staticClass: "icon-group"
  }, [_c("i", {
    staticClass: "fa fa-file-photo-o",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        _vm.videoVisible = true;
      }
    }
  }), _c("i", {
    staticClass: "fa fa-close",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.deleteVideo();
      }
    }
  })]) : _vm._e()], 1), _vm._l(_vm.form.image_urls, function (item, index) {
    return _c("div", {
      directives: [{
        name: "dragging",
        rawName: "v-dragging",
        value: {
          item: item,
          list: _vm.form.image_urls,
          group: "item"
        },
        expression: "{\n                            item: item,\n                            list: form.image_urls,\n                            group: 'item',\n                        }"
      }],
      key: index,
      staticClass: "wlc-image-item"
    }, [_c("img", {
      staticClass: "img",
      attrs: {
        src: _vm.thumbnailUrl(item)
      },
      on: {
        click: function click($event) {
          return _vm.setCover(item);
        }
      }
    }), item == _vm.form.cover_url ? _c("img", {
      staticClass: "icon-cover",
      attrs: {
        src: "".concat(_vm.$baseUrl, "image/icon-cover.png"),
        width: "50px"
      }
    }) : _vm._e(), _c("div", {
      staticClass: "icon-group"
    }, [_c("i", {
      staticClass: "fa fa-eye",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.previewImage(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-repeat",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.selectRotateImg(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-close",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.deleteImage(index, item);
        }
      }
    })])]);
  }), _c("wlc-upload-image", {
    attrs: {
      url: _vm.form.url,
      visible: false,
      width: "200px",
      height: "150px",
      multimediaType: "wellceeCommunity"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "url", $event);
      }
    }
  })], 2), _c("el-form", {
    staticClass: "wlc-form-section lifestyle-info",
    attrs: {
      "label-width": "40px"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: 16
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "标题"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _vm.form.title_is_custom == 0 ? _c("el-tag", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: "success"
    }
  }, [_vm._v("系统抓取 ")]) : _vm._e(), _vm.form.location_city ? _c("el-tag", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: "info"
    }
  }, [_vm._v("发布地：" + _vm._s(_vm.form.location_city) + " ")]) : _vm._e(), _vm.form.ip_city ? _c("el-tag", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: _vm.form.location_match_status == 2 ? "danger" : "info"
    }
  }, [_vm._v("IP属地：" + _vm._s(_vm.form.ip_city) + " ")]) : _vm._e(), _c("el-tag", {
    attrs: {
      type: "info"
    }
  }, [_vm._v("发布时间：" + _vm._s(_vm.form.created_at) + " ")])], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "地址"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.location,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "location", $$v);
      },
      expression: "form.location"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    staticClass: "lifestyle-desc",
    attrs: {
      label: "描述"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "10",
      autosize: ""
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _vm.showPrice ? _c("el-row", {
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: "6"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "价格"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: ""
    },
    model: {
      value: _vm.form.price,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "price", $$v);
      },
      expression: "form.price"
    }
  }, [_c("template", {
    slot: "prepend"
  }, [_vm._v("¥")])], 2)], 1)], 1)], 1) : _vm._e()], 1), _c("TagList", {
    ref: "tagList",
    model: {
      value: _vm.form.admin_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "admin_tags", $$v);
      },
      expression: "form.admin_tags"
    }
  }), _c("CategoryList", {
    attrs: {
      AIList: _vm.form.categoryList
    },
    on: {
      changeAssayValue: _vm.changeAssayValue
    },
    model: {
      value: _vm.form.adminCategoryList,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "adminCategoryList", $$v);
      },
      expression: "form.adminCategoryList"
    }
  }), _c("FlowPool", {
    model: {
      value: _vm.form.flow_pool,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "flow_pool", $$v);
      },
      expression: "form.flow_pool"
    }
  }), (_vm$postLog = _vm.postLog) !== null && _vm$postLog !== void 0 && _vm$postLog.length ? _c("PostLog", {
    attrs: {
      list: _vm.postLog,
      loading: _vm.loadingLog
    }
  }) : _vm._e(), _c("el-form", [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")]), _vm.form.audit_status == 0 ? _c("el-button", {
    ref: "passBtn",
    attrs: {
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.audit(1, 0);
      }
    }
  }, [_vm._v("通过 ")]) : _vm._e(), _c("RejectModal", {
    ref: "rejectModal",
    on: {
      reject: _vm.reject
    }
  }, [_vm.form.audit_status == 0 ? _c("el-button", {
    ref: "rejectBtn",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      type: "info"
    }
  }, [_vm._v("拒绝 ")]) : _vm._e()], 1), _vm.btnNextVisible ? _c("wlc-btn-next", {
    ref: "btnNext"
  }) : _vm._e()], 1)], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "选择封面",
      visible: _vm.videoVisible,
      width: "90%"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.videoVisible = $event;
      }
    }
  }, [_c("video", {
    staticStyle: {
      width: "100%",
      height: "600px"
    },
    attrs: {
      src: _vm.form.video_url,
      controls: "controls",
      id: "J_video"
    }
  }, [_vm._v(" 您的浏览器不支持 video 标签。 ")]), _c("div", {
    staticStyle: {
      "text-align": "center",
      margin: "20px 0"
    }
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.videoVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.selectVideoPreview
    }
  }, [_vm._v("确 定 ")])], 1)]), _c("el-dialog", {
    staticClass: "wlc-image-preview",
    attrs: {
      top: "5vh",
      fullscreen: true,
      visible: _vm.previewDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.previewDialogVisible = $event;
      }
    }
  }, [_c("el-carousel", {
    ref: "carousel",
    attrs: {
      "indicator-position": "none",
      autoplay: false,
      arrow: "always"
    }
  }, _vm._l(_vm.form.image_urls, function (item) {
    return _c("el-carousel-item", {
      key: item
    }, [_c("img", {
      staticStyle: {
        width: "100%",
        height: "100%",
        "object-fit": "contain"
      },
      attrs: {
        src: item
      }
    })]);
  }), 1)], 1)], 1), _vm.imageRotateDialogVisible ? _c("wlc-image-rotate", {
    attrs: {
      url: _vm.imageRotateUrl
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };